import type { DeviceStats, VisitorStats } from '~/types/graphql';
import type { IAnalyticMetric } from '~/types/metric';

import { mapBarChartDataSeries } from '../../helpers';
import { capitalizeFirstLetter } from '~/utils';

export const useVisitorDataSeries = () => {
  const defaultVisitors: DeviceStats[] = [
    { totalCount: 0, type: 'new' },
    { totalCount: 0, type: 'returning' },
  ];

  const mapVisitorData = (metric?: IAnalyticMetric) => {
    const mergedVisitors = defaultVisitors.map((defaultVisitor) => {
      const matchedVisitor = (
        metric?.visitors || [
          {
            totalCount: 0,
            type: 'new',
          },
          {
            totalCount: 0,
            type: 'returning',
          },
        ]
      )?.find((visitor) => visitor?.type === defaultVisitor.type);
      return {
        ...defaultVisitor,
        totalCount: matchedVisitor ? matchedVisitor.totalCount : defaultVisitor.totalCount,
      };
    });

    return mapBarChartDataSeries<VisitorStats>(mergedVisitors, capitalizeFirstLetter);
  };

  return { mapVisitorData };
};
